import { ContainerBase } from './containerBase';
import React from 'react';
import styled from 'styled-components';

export const ContainerSmall = styled(ContainerBase)`
    max-width: 600px;
`;
